import React, { FunctionComponent } from 'react';
import {
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import moment, { Moment } from 'moment';

import { IUser } from '../../../store/UserSlice';
import { getShortName } from '../../../helper';

interface AdminNoteCardProps {
  note: {
    _id: string;
    description: string;
    createdBy: IUser;
    createdAt: string;
  };
  disableDelete?: boolean;
  onDelete?: () => void;
}

const AdminNoteCard: FunctionComponent<AdminNoteCardProps> = ({
  note,
  disableDelete,
  onDelete,
}) => {
  const createdAt = moment(note.createdAt);

  return (
    <Card
      elevation={0}
      sx={{ backgroundColor: '#F8F9FD', borderRadius: '7px' }}
    >
      <CardContent style={{ padding: '10px 16px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack>
            <Typography fontSize="14px" fontWeight={500} mb="10px">
              {note.description}
            </Typography>
            <Typography fontSize="10px" fontWeight={500}>
              {createdAt.format('ddd MMM DD YYYY hh:mm A')}
            </Typography>
            <Typography fontSize="10px" fontWeight={500}>
              {getShortName(
                note.createdBy.firstname,
                note.createdBy.lastname,
                true
              )}
            </Typography>
          </Stack>
          <IconButton disabled={disableDelete} color="error" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AdminNoteCard;
